import BlogDisplayArticle from "./BlogDisplayArticle";
import { useLocation } from "react-router-dom";
import blogInfo from "./BlogInfo";

const BlogPage = () => {
  const location = useLocation().pathname.substring(1);

  if (location in blogInfo) {
    return <BlogDisplayArticle url={`${blogInfo[location]}/article`} />;
  } else {
    return <BlogDisplayArticle url="/blogdata/contents" />;
  }
};

export default BlogPage;
